import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HostingDomainData} from "../hostingDomainData";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import {Website} from "../../../website";
import {Config} from "../../../../../config/config";
import {
  ConfirmDomainDeleteDialogComponent
} from "./confirm-domain-delete-dialog/confirm-domain-delete-dialog.component";
import {
  DisconnectWebsiteAndMakeDialogComponent
} from "./disconnect-website-make-primary-dialog/disconnect-website-make-primary-dialog.component";
import {DomainTroubleshootMapper} from "../domain-troubleshoot-mapper";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {IDropdownListItem} from "../../../../../shared/components/dropdown-list/dropdown-list-item";
import {UserSubscription, UserSubscriptionType} from "../../../../../user/user-subscription";
import {User} from "../../../../../user/user";
import {filter, first} from "rxjs/operators";
import {Payment} from "../../../../../user/payment";
import {DbModalService} from "../../../../../modules/modal/modal";
import {MakePrimaryDialogComponent} from "./make-primary-dialog/make-primary-dialog.component";
import {AddDomainSuccessDialogComponent} from "../add-domain-succes-dialog/add-domain-success-dialog.component";
import {
  AddCustomDomainSuccessDialogComponent
} from "../add-custom-domain-succes-dialog/add-custom-domain-success-dialog.component";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {ApproveEditModalComponent} from "./components/approve-edit-modal/approve-edit-modal.component";
import {MainDomainI} from "../../../../../components/pages/10web-API/components/custom-domain/custom-domain.interface";

@Component({
    selector: 'db-domain-item',
    templateUrl: './domain-item.component.html',
    styleUrls: ['./domain-item.component.scss'],
    standalone: false
})
export class DomainItemComponent implements OnInit {

  @Input() domain: HostingDomainData;
  @Input() website: Website;
  @Input() companyName: string;
  @Input() primaryChanged: boolean;
  @Input() primaryDomain: HostingDomainData;
  @Input() user: User;
  @Input() payments: Payment[];
  @Input() currentSubscription: UserSubscription;
  @Input() checkStatusesLoading: boolean;
  @Input() nameServers: string[];
  @Input() ipv4Address: string;
  @Input() mainDomain: MainDomainI | null;

  @Output() actionDone: EventEmitter<void>;
  @Output() primaryActionDone: EventEmitter<void>;
  @Output() onManageClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() showLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  public primaryLoading: boolean;
  public isPointedDomainLoading: boolean;
  public cantRemoveDomain: boolean = false;
  public buttonClicked: boolean = false;
  public domainNameIds: any;
  public removeDomain: IDropdownListItem[];
  public isMobile: boolean;
  public is1WFclient: boolean;
  public Config = Config;
  public isCopied: boolean;

  statusOptions = [
    {
      value: 'pointed',
      label: "Pointed"
    },
    {
      value: 'notPointed',
      label: "No pointed"
    },
    {
      value: 'checking',
      label: "Checking"
    },

  ];

  constructor(
    private _hostingService: HostingService,
    private _dbModalService: DbModalService,
  ) {
    this.actionDone = new EventEmitter<void>();
    this.primaryActionDone = new EventEmitter<void>();

  }

  ngOnInit() {
    this.is1WFclient = this.user && this.user.planType === UserSubscriptionType.PLATFORM && this.payments && !this.payments.length;
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
    this.removeDomain = [
      {
        icon: 'plugins',
        label: 'Remove Domain',
        action: (item) => {
          this.confirmRemove(item.name, item.id);
        }
      }
    ];
    Config.hostnameList.map((hostname) => {
      if (this.domain.name.indexOf(hostname) !== -1) {
        this.cantRemoveDomain = true;
      }
    });

  }

  public copied() {
    this.isCopied = true;
    setTimeout(() => this.isCopied = false, 800);
  }

  public isMainDomain(): boolean {
    if (!this.mainDomain || !this.domain?.name) {
      return false;
    }
    const domainHostname = this.domain.name;
    const mainDomainHostname = this.mainDomain.main_domain;
    // Check if domain is exactly the main domain or a subdomain of it
    const isExactMatch = domainHostname === mainDomainHostname;
    const isSubdomain = domainHostname.endsWith('.' + mainDomainHostname);
    return isExactMatch || isSubdomain;
  }

  public confirmRemove(domainName, domainId) {
    const modal = this._dbModalService.open(ConfirmDomainDeleteDialogComponent, {width: 700});
    modal.componentInstance.message = TextUtils.getText('text_confirmDomainNameRemove.message', {
      domainName: domainName
    });
    modal.componentInstance.cdnMessage = !!this.domain.cfEnabled ? TextUtils.getText('text_confirmDomainNameRemove.cdnMessage') : '';
    modal.componentInstance.domainId = domainId;
    modal.componentInstance.websiteId = this.website?.id;
    modal.componentInstance.childWebsiteId = this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : null;
    modal.componentInstance.confirmButtonText = TextUtils.getText('text_removeDemoWebsiteBtn');
    modal.componentInstance.cancelButtonText = TextUtils.getText('text_cancel');
    modal.componentInstance.header = TextUtils.getText('text_confirmDomainNameRemove.header');
    modal.closed.subscribe((value) => {
      this.actionDone.emit();
    });
  }

  public confirmMakePrimary(domainName, domainId, domainWebsiteId, isConnected) {
    this.buttonClicked = true;
    if (isConnected) {
      const passwordMessage = !this.website.isNetwork ?
        this.currentSubscription.type === UserSubscriptionType.FREE ?
          TextUtils.getText('text_typeRemoveWebsiteMakePrimaryTrials') :
          TextUtils.getText('text_typeRemoveWebsiteMakePrimary') :
        TextUtils.getText('text_typeRemoveWebsiteMakePrimaryNetwork');
      const modal = this._dbModalService.open(DisconnectWebsiteAndMakeDialogComponent, {width: 700});
      modal.componentInstance.message = TextUtils.getText('text_confirmMakePrimary.message', {
        domainName: domainName
      });
      modal.componentInstance.passwordMessage = passwordMessage;
      modal.componentInstance.websiteId = domainWebsiteId;
      modal.componentInstance.currentWebsiteId = this.website.id;
      modal.componentInstance.domainNameId = domainId;
      modal.componentInstance.currentSubscription = this.currentSubscription;
      modal.componentInstance.website = this.website;
      modal.componentInstance.companyName = this.companyName;
      modal.closed.subscribe((value) => {
        if (value && value.success) {
          NotifierComponent.notify(new Notification("Primary domain changed successfully", NotificationType.SUCCESS));
          this.primaryActionDone.emit();
        }
        this.buttonClicked = false;
      });
    } else {
      this.checkIfDomainIsPointed(domainName, domainId);
    }
  }

  public manageDns(zoneId) {
    this.onManageClick.emit(zoneId);
  }

  public checkDetails(isPointed: boolean, isTenWebDomain: boolean, isTenWebNS: boolean, domainName: string, domainZoneID: string): void {
    if (this.domain?.verificationNeeded || this.domain?.pending) {
      this._openNotificationPopup();
    } else if (TypeUtils.isUndefined(domainZoneID)) {
      this.showTenWebDomainDetails(isPointed, isTenWebDomain, isTenWebNS, domainName, null, true);
    } else if (!isPointed && !isTenWebDomain && !isTenWebNS) {
      this.showCustomAndCustomNSNotPointedDialog(isPointed, isTenWebDomain, isTenWebNS, domainName, domainZoneID);
    } else {
      this.showTenWebDomainDetails(isPointed, isTenWebDomain, isTenWebNS, domainName, domainZoneID);
    }

  }

  public showTenWebDomainDetails(isDomainPointed: boolean, isTenWebDomain: boolean, isTenWebNS: boolean, domainName, domainZoneID, zoneIssues?: boolean): void {
    const modal = this._dbModalService.open(AddDomainSuccessDialogComponent, {width: 700});
    modal.componentInstance.fromDetails = true;
    modal.componentInstance.isDomainPointed = isDomainPointed;
    modal.componentInstance.isTenWebDomain = isTenWebDomain;
    modal.componentInstance.isTenWebNS = isTenWebNS;
    modal.componentInstance.domainZoneID = domainZoneID;
    modal.componentInstance.domainName = domainName;
    modal.componentInstance.ipv4Address = this.ipv4Address;
    modal.componentInstance.zoneIssues = zoneIssues ? zoneIssues : false;
  }

  public showCustomAndCustomNSNotPointedDialog(isDomainPointed: boolean, isTenWebDomain: boolean, isTenWebNS: boolean, domainName, domainZoneID): void {
    const modal = this._dbModalService.open(AddCustomDomainSuccessDialogComponent, {width: 700});
    modal.componentInstance.fromDetails = true;
    modal.componentInstance.domainZoneID = domainZoneID;
    modal.componentInstance.domainName = domainName;
    modal.componentInstance.ipv4Address = this.ipv4Address;
    modal.componentInstance.isDomainPointed = isDomainPointed;
  }

  private checkIfDomainIsPointed(domainName, domainId) {
    this.isPointedDomainLoading = true;
    this.domainNameIds = [];
    this.domainNameIds.push(domainId);
    this._hostingService.checkPointedDomain(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id, this.domainNameIds)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.isPointedDomainLoading = false;
        if (response.success) {
          this.makeDomainPrimaryDialog(response, domainId, domainName);
        }
      });
    this.buttonClicked = false;
  }

  private makeDomainPrimaryDialog(pointedResponse, domainId, domainName, isConnected = false) {
    const isPointed = DomainTroubleshootMapper.map(pointedResponse.data, domainId).pointed;
    const suspectedUser = this.user && this.user.isSuspected;
    const disableMakePrimary = (this.is1WFclient || suspectedUser) && !isPointed;
    const modal = this._dbModalService.open(MakePrimaryDialogComponent, {width: 700});
    modal.componentInstance.companyName = this.companyName;
    modal.componentInstance.isConnected = isConnected;
    modal.componentInstance.message = TextUtils.getText(isPointed ? 'text_confirmMakePrimary.message' : (disableMakePrimary ? 'text_confirmMakePrimaryNotPointed.message1WF' : 'text_confirmMakePrimaryNotPointed.message'), {domainName: domainName, companyName: this.companyName});
    modal.componentInstance.cancelButtonText = disableMakePrimary ? TextUtils.getText('text_gotIt') : TextUtils.getText('text_cancel');
    modal.componentInstance.confirmButtonText = TextUtils.getText('text_confirmMakePrimary.button');
    modal.componentInstance.cancelButtonClass = disableMakePrimary ? "ds-btn-black" : 'ds-btn';
    modal.componentInstance.ssl = DomainTroubleshootMapper.map(pointedResponse.data, domainId).ssl || this.cantRemoveDomain || disableMakePrimary;
    modal.componentInstance.pointed = isPointed;
    modal.componentInstance.disableMakePrimary = disableMakePrimary;
    modal.componentInstance.isOneWeekFree = disableMakePrimary;
    modal.closed.subscribe((value) => {
      if (value) {
        if (value.enableSSL) {
          this.makeDomainPrimary(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id, domainId, true)
            .then(() => {
              this._hostingService.generateFreeCertificate(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id, this.domainNameIds, 1)
                .pipe(
                  filter((_response: DbResponse): boolean => !!_response),
                  first()
                ).subscribe((_response: DbResponse): void => {
                if (_response.success) {
                  NotifierComponent.notify(new Notification("Certificate created successfully", NotificationType.SUCCESS));
                } else {
                  NotifierComponent.notify(new Notification("Certificate not created", NotificationType.DANGER));
                }
                this.primaryLoading = false;
              });
            });
        }
        else {
          this.makeDomainPrimary(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id, domainId);
        }
      }
    });
  }

  private async makeDomainPrimary(websiteId, domainId, withSSL = false) {
    this.primaryLoading = true;
    this.showLoading.emit(true);
    await new Promise((resolve: Function, reject: Function): void => {
      this._hostingService.makeDomainPrimary(websiteId, domainId)
        .pipe(
          first(response => !!response, null)
        )
        .subscribe(response => {
          if (response.success) {
            NotifierComponent.notify(new Notification("Primary domain changed successfully", NotificationType.SUCCESS));
            this.primaryActionDone.emit();
          }
          if (!withSSL) {
            this.primaryLoading = false;
          }
          resolve(true);
        });
    });
  }

  private _openNotificationPopup() {
    const modal = this._dbModalService.open(ApproveEditModalComponent, {width: 701});
    let title = 'text_emailVerification';
    let message = 'text_emailVerificationMessage';

    if (this.domain?.pending) {
      title = 'text_domainInProgress';
      message = 'text_domainInProgressMess';
    }

    modal.componentInstance.modalValue = {
      title: TextUtils.getText(title),
      message: TextUtils.getText(message),
    };
  }

}
